import Vue from "vue";
import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";

const PatientFormProps = Vue.extend({
  props: {
    service: Object as () => ServiceInterface,
    patient: String,
    showErrors: Boolean,
    cxShowTerms: Boolean,
    incompletePatientInfo: Boolean,
    notRegisteredPatient: Object,
  },
});

export default PatientFormProps;
